import { observer } from "mobx-react-lite";
import { useRef } from "react";

import MessagesScrollContainer from "./Messages/MessagesScrollContainer";
import type { ChatMessage, VibeChatStore } from "./stores";

import { cn } from "@/lib/utils";

interface MessagesProps {
  messages: ChatMessage[];
  isLoading: boolean;
  chatStore: VibeChatStore;
  className?: string;
  onRetry?: (messageIndex?: number) => void;
}

export const Messages = observer(
  ({ messages, isLoading, chatStore, className, onRetry }: MessagesProps) => {
    const containerRef = useRef<HTMLDivElement | null>(null);

    return (
      <div className={cn("flex min-h-0 flex-1 flex-col", className)}>
        <MessagesScrollContainer
          containerRef={containerRef}
          messages={messages}
          isLoading={isLoading}
          chatStore={chatStore}
          onRetry={onRetry}
        />
      </div>
    );
  },
);
